import { getStorage } from "firebase/storage";
import { ref, uploadString, uploadBytes, getDownloadURL, getBlob, listAll } from "firebase/storage";

// Inizializza Storage
export const storage = getStorage();

export function testGStorage() {
  let storageRef = ref(storage, 'test.tst');
      // Raw string is the default if no format is provided
  const message = 'This is my message.';
  uploadString(storageRef, message)
    .then(() => {
      console.log('Uploaded a raw string!');
    })
    .catch((error) => {
      console.error('Error uploading string:', error);
    });

}

export function testFileStorage(file, nomeFile) {
  let storageRef = ref(storage, nomeFile);
      // Raw string is the default if no format is provided
  uploadBytes(storageRef, file)
    .then(() => {
      console.log('Uploaded a file!');
    })
    .catch((error) => {
      console.error('Error uploading file:', error);
    });
  console.log('P3');

}

/**
 * Scarica un file da Firebase Storage.
 * Cerca sia nel percorso esatto fornito sia con prefisso 'backup/' se non presente.
 * Utilizza prima getBlob / fetch con ObjectURL e dispone di fallback su downloadURL diretto anti-CORS.
 */
export async function downloadFile(nomeFile) {
  if (!nomeFile || typeof nomeFile !== 'string' || !nomeFile.trim()) {
    throw new Error('Specificare un nome file o percorso valido.');
  }

  const percorsoOriginale = nomeFile.trim();

  // Costruisce i percorsi alternativi da testare in ordine di probabilità
  const percorsiDaProvare = [];
  if (!percorsoOriginale.includes('/')) {
    // Prova prima sotto la cartella 'backup/' e poi nel percorso root
    percorsiDaProvare.push(`backup/${percorsoOriginale}`);
    percorsiDaProvare.push(percorsoOriginale);
  } else {
    percorsiDaProvare.push(percorsoOriginale);
    if (percorsoOriginale.startsWith('backup/')) {
      percorsiDaProvare.push(percorsoOriginale.replace(/^backup\//, ''));
    }
  }

  let fileRef = null;
  let downloadUrl = null;

  for (const p of percorsiDaProvare) {
    try {
      const r = ref(storage, p);
      downloadUrl = await getDownloadURL(r);
      fileRef = r;
      break;
    } catch {
      // Ignora e continua con il prossimo percorso
    }
  }

  if (!fileRef || !downloadUrl) {
    throw new Error(`File non trovato su Firebase Storage. Percorsi verificati: "${percorsiDaProvare.join('", "')}".`);
  }

  const filename = estraiNomeFile(fileRef.fullPath || percorsoOriginale);

  // Strategia 1: Scaricamento blob tramite Firebase SDK getBlob o fetch
  let blobScaricato = null;
  try {
    blobScaricato = await getBlob(fileRef);
  } catch (errBlob) {
    console.warn("[STORAGE] getBlob non riuscito, tento con fetch(downloadUrl)...", errBlob);
    try {
      const resp = await fetch(downloadUrl);
      if (resp.ok) {
        blobScaricato = await resp.blob();
      }
    } catch (errFetch) {
      console.warn("[STORAGE] fetch non riuscito (possibile CORS), uso fallback su apertura diretta:", errFetch);
    }
  }

  if (blobScaricato) {
    const blobUrl = URL.createObjectURL(blobScaricato);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      URL.revokeObjectURL(blobUrl);
    }, 10000);
  } else {
    // Strategia 2: Fallback anti-CORS aprendo/scaricando direttamente l'URL firmato
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return { success: true, filename, url: downloadUrl };
}

/**
 * Elenca i file presenti nella cartella 'backup' di Firebase Storage.
 */
export async function elencaFileBackup() {
  const folderRef = ref(storage, 'backup');
  const res = await listAll(folderRef);
  return res.items.map(item => item.name).sort().reverse();
}

/* Estrae il nome del file da un percorso completo.
* Es. 'directory/nomefile.est' -> 'nomefile.est'
*/
export function estraiNomeFile(percorso) {
    if (!percorso || typeof percorso !== 'string') return '';
    
    // Divide la stringa basandosi su slash o backslash e restituisce l'ultimo elemento
    return percorso.split(/[\\/]/).pop();
}
